class TimeoutWarningService {

    constructor() {
        'ngInject';

        const autoLogoutTotalDelay = 1800; // 30 minutes in seconds
        this.autoLogoutTimeoutTime = 120; // 2 minutes in seconds
        this.autoLogoutIdleTime = autoLogoutTotalDelay - this.autoLogoutTimeoutTime;

        this.isModalOpen = false;
    }

}

export default TimeoutWarningService;


// WEBPACK FOOTER //
// ./app/common/timeout-warning/timeout-warning-service.js